export var State;
(function (State) {
    State[State["Normal"] = 0] = "Normal";
    State[State["Offline"] = 1] = "Offline";
    State[State["Unbind"] = 2] = "Unbind";
    State[State["Abnormal"] = 3] = "Abnormal";
    State[State["Loading"] = 4] = "Loading";
    State[State["Disable"] = 9] = "Disable";
})(State || (State = {}));
